define.alias("shared/utils/canvas-video-player", "preview-grid/utils/canvas-video-player");